const GA_MEASUREMENT_ID = 'G-45P4BQ6XJR';

const isProduction = () =>
    window.location.hostname !== 'localhost' &&
    window.location.hostname !== '127.0.0.1';

/** Returns true if this browser has been manually flagged as internal/developer traffic.
 *  To flag your own browser: localStorage.setItem('ga_internal', '1')
 *  To unflag:                localStorage.removeItem('ga_internal')
 */
const isInternalTraffic = () => localStorage.getItem('ga_internal') === '1';

export const initGoogleAnalytics = () => {
    if (!isProduction() || isInternalTraffic()) return;
    if (document.getElementById('ga-script')) return;

    const script1 = document.createElement('script');
    script1.id = 'ga-script';
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${GA_MEASUREMENT_ID}', { send_page_view: false });
    `;
    document.head.appendChild(script2);
};

/** Call after a user logs in or is restored from localStorage. */
export const setGAUserId = (userId) => {
    if (!isProduction() || typeof window.gtag !== 'function') return;
    window.gtag('config', GA_MEASUREMENT_ID, { user_id: String(userId) });
};

/** Call when a user logs out. */
export const clearGAUserId = () => {
    if (!isProduction() || typeof window.gtag !== 'function') return;
    window.gtag('config', GA_MEASUREMENT_ID, { user_id: undefined });
};

/** Call on every React route change to fire a page_view hit. */
export const trackPageView = (path) => {
    if (!isProduction() || typeof window.gtag !== 'function') return;
    window.gtag('event', 'page_view', {
        page_path: path,
        page_location: window.location.href,
    });
};
